import * as React from "react";
import { useEffect, useRef } from "react";
import { Redirect, useHistory } from "react-router-dom";
import { Itemset } from "../../../../store/viewmodels/ItemsetViewModel";
import { Item } from "../../../../store/viewmodels/ItemViewModel";
import { Task } from "../../../../store/viewmodels/TaskViewModel";
import { ItemsetResult } from "../../../../store/viewmodels/ItemsetViewModel";
import { getNextUrl, postCheck } from "../../../../utils/TaskNavigationServices";
import { getFileElement } from "../../../../utils/TaskContentServices";
import { addAnswerToSet, addItemSet, addStudentId, postAnswerSet, setStartTime, setEndTime, resetAsSliceState, postAnswerFile } from "../../../../store/AnswerSetSlice";
import { useAppDispatch } from "../../../../store/Hooks";
import { StudentData } from '../../../../store/viewmodels/StudentViewModel';
import { Answer } from "../../../../store/viewmodels/AnswerViewModel";
import { useAppSelector } from "../../../../store/Hooks";
import HoverVideoPlayer from "../../../../utils/HoverVideoPlayer/HoverVideoPlayer";
import Header from "../Header";

export interface StudentVideoRecordingProps {
    task: Task,
    itemset: Itemset,
    item: Item,
}

declare var MediaRecorder: any;
let videoFile: File;

function StudentVideoRecording(props: StudentVideoRecordingProps) {
    const history = useHistory();
    const dispatch = useAppDispatch();
    const studentData: StudentData = useAppSelector(state => state.studentData);
    const constraints = {
        audio: false,
        video: {
            width: 640, height: 480,
            frameRate: 20
        }
    }

    let aStartTime = new Date();
    let videoRef = useRef(null);
    const [downloadURL, setDownloadURL] = React.useState("");

    let chunks: any[] = [];
    let videoURL: string = "";
    let blob: Blob;
    //let videoFile: File;
    let nextUrl = getNextUrl(props.itemset, props.item, props.task, studentData.student.active_item_sets)
    let streamRef: any;
    let MediaRecorderState: any;

    const [refState, setRefState] = React.useState(streamRef);
    const [stateMedRec, setStateMedRec] = React.useState(MediaRecorderState);
    const [getVideoCheck, setGetVideoCheck] = React.useState(false);
    const [buttonState, setButtonState] = React.useState("closed");
    const [answerFile, setAnswerFile] = React.useState<File>();
    const [userPermission, setUserPermission] = React.useState(true);
    const [hideRecorder, setHide] = React.useState(false);
    const [fileAvailable, setFileAvailable] = React.useState(false);
    const [clear, setClear] = React.useState(false);
    const [goForward, setForward] = React.useState(false);


    useEffect(() => {
        const itemset: ItemsetResult = { id: props.itemset.id, name: props.itemset.name, type: props.itemset.type }
        dispatch(addStudentId(studentData.student.id));
        dispatch(addItemSet(itemset));
        let asStartTime: Date = new Date()
        dispatch(setStartTime(asStartTime.toISOString()));
        setHide(true);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (clear) {
            recordAgain();
            setClear(false);
            setForward(true);
        }
    }, [clear])

    const getFileName = () => {
        const itemset: Itemset = props.itemset;
        const item: Item = props.item;
        const user: string = studentData.student.username;
        let itemSetName: string = itemset?.name ? itemset.name : '';
        let itemName: string = item?.name ? item.name : '';
        if (itemSetName) { itemSetName = itemSetName.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, ''); }
        if (itemName) { itemName = itemName.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, ''); }

        let currentdate = new Date();
        let datetime = currentdate.getDate() + "_"
            + (currentdate.getMonth() + 1) + "_"
            + currentdate.getFullYear() + "_"
            + currentdate.getHours() + "_"
            + (currentdate.getMinutes() < 10 ? '0' : '') + currentdate.getMinutes();

        return user + '_' + itemSetName + '_' + itemName + '_' + datetime + '.mp4';
    }

    const getVideo = async () => {
        navigator.mediaDevices.getUserMedia(constraints)
            .then(stream => {
                const options = {
                    videoBitsPerSecond: 700000,
                }
                let mediaRecorder = new MediaRecorder(stream, options);
                let video: HTMLVideoElement = videoRef?.current!; //This is some clown fiesta right here, but due to TS strict typing and the way the UserMedia API returns values...
                video.srcObject = stream;
                setStateMedRec(mediaRecorder);
                video.play();
                setGetVideoCheck(false);
                setUserPermission(true);
                mediaRecorder.ondataavailable = function (e: any) {
                    chunks.push(e.data);
                }
                mediaRecorder.onstop = function () {
                    const fileName: string = getFileName()
                    blob = new Blob(chunks)
                    videoFile = new File(chunks, fileName)
                    setAnswerFile(videoFile)
                    videoURL = URL.createObjectURL(blob)
                    setDownloadURL(videoURL)
                    chunks = []
                }
            })
            .catch(err => {
                console.error("error:", err);
                setUserPermission(false);
            });
    };

    useEffect(() => {
        if (getVideoCheck === true) {
            getVideo();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getVideoCheck]);

    const commitAnswer = () => {
        let answer: Answer = {} as Answer;
        let aEndTime = new Date();
        const item = props.item
        const postFileObject = { file: answerFile, itemRef: item }
        answer.item = props.item.id
        answer.value = props.item.name;
        answer.end_time = aEndTime.toISOString()
        answer.start_time = aStartTime.toISOString()
        dispatch(addAnswerToSet(answer));
        dispatch(postAnswerFile(postFileObject))
        const postAnswerSetCheck: boolean = postCheck(props.itemset, props.item, props.task, studentData.student.active_item_sets);
        if (postAnswerSetCheck === false) {
            setGetVideoCheck(true);
            // getVideo()
        } else {
            let asEndTime = new Date();
            dispatch(setEndTime(asEndTime.toISOString()));
            dispatch(postAnswerSet())
                .then(() => {
                    dispatch(resetAsSliceState())
                })
        }
        setButtonState("closed");
        history.push(nextUrl);
    }

    const recordAgain = () => {
        setHide(false);
        setButtonState("");
        setFileAvailable(false);
        setForward(false);
    }

    const startRecording = () => {
        if (!stateMedRec) { getVideo(); }
        if (stateMedRec?.state === "inactive") {
            stateMedRec?.start();
            setButtonState("recording");
        }
        setFileAvailable(false);
    }

    const stopRecording = () => {
        setHide(true);
        if (!stateMedRec) { getVideo(); }
        if (stateMedRec?.state === "recording") {
            stateMedRec?.stop();
            setButtonState("stopped");
            refState?.getTracks().forEach((track: any) => {
                track.stop();
            });
        }
        //setForward(true);
    }

    useEffect(() => {
        if (answerFile) setForward(true);
    }, [answerFile])

    const openCamera = () => {
        setButtonState("");
        setHide(false);
        getVideo();
    }

    let videoRecorder: JSX.Element = <video className="overflow-hidden rounded-2xl " ref={videoRef} />;
    let instructions: JSX.Element = getFileElement(props.item.files?.[0]);

    let videoPlayer: JSX.Element = (
        <div className="flex w-full" key={"HoverVideoPlayer_watchRecord"}>
            <HoverVideoPlayer key={""} videoSrc={downloadURL} preload="auto" srcType="video/mp4" />
        </div>);

    let recorderCover: JSX.Element = <div className={hideRecorder ? "bg-gray-400 h-full w-full z-10 absolute " : "hidden"}>{fileAvailable ? videoPlayer : <></>}</div>

    let taskComponent: JSX.Element = <div></div>;
    if (props.item.files.length > 0) {
        taskComponent = (
            <div className="flex justify-center">
                <div className='flex h-full w-1/2 justify-center mr-2 lg:mr-5'>
                    <div className="flex my-auto overflow-hidden rounded-2xl ring-gray-200 ring-4 lg:ring-8">
                        {instructions}
                    </div>
                </div>
                <div className='flex my-auto max-h-full max-w-1/2 justify-center ml-2 lg:ml-5'>
                    <div className="justify-center my-auto overflow-hidden rounded-2xl ring-teal-500 ring-4 lg:ring-8 relative w-full h-full">
                        {recorderCover}
                        <div className="relative">
                            <span className={stateMedRec?.state === "recording" ? "absolute ri-record-circle-fill z-9 text-2xl text-red-600 top-1.5 left-1.5" : "hidden"}></span>
                            {videoRecorder}
                        </div>
                    </div>
                </div>
            </div>);
    }
    else {
        taskComponent = (
            <div className="flex justify-center w-full">
                <div className="overflow-hidden rounded-2xl shadow content-center ring-teal-500 ring-4 lg:ring-8 relative">
                    <div className={hideRecorder ? "bg-gray-400 h-full w-full z-10 absolute " : "hidden"}></div>
                </div>
            </div>
        );
    }

    return (
        userPermission ?
            <div className="h-fit w-fit">
                <div className="h-5/6 justify-center my-auto mt-5">
                    <div className="h-5/6 w-full justify-center my-auto flex">
                        {taskComponent}
                    </div>
                    <div className="h-1/6 mt-5">
                        <Header commitAnswer={commitAnswer} goForward={goForward} type={"videoRecording"} setClear={recordAgain} open={openCamera} start={startRecording}
                            stop={stopRecording} recordAgain={recordAgain}
                            setFileAvailable={setFileAvailable} buttonState={buttonState} />
                    </div>
                </div>
            </div>
            :
            <div>
                <Redirect to='/student/tasks' />
            </div>
    );
}


export default StudentVideoRecording